import React from 'react';
import {trackClick} from 'utility/analytics';
import {openModal} from 'state/modals/actions';
import {Button} from 'theme/Button';
import { XXL, LG, MD } from '@zendeskgarden/react-typography';
import Flex from 'styled-flex-component';
import { Row, Col } from '@zendeskgarden/react-grid';
import { HeroHeader } from './RfShieldingHero.styles.js';


const RfShieldingHero = (props) => {
  function goTorequest(data) {
    trackClick('inquire', 'Inquire About A Service', 'RFShieldingHero');
    openModal({
      type: 'inquireFormModal',
      data: {
        selectService: true,
        activeService: props.activeService
      }
    })
  }
  return (
      <HeroHeader>
        <div>
          <Row>
            <Col md={12}>
              <div>
                <Flex alignCenter>
                  <XXL style={{maxWidth: '1000px', fontSize: '33px'}} light navy tag="h1">MRT RF Shielding</XXL>
                </Flex>
                <XXL style={{maxWidth: '1000px'}} bold paddingTopMd navy tag="h1">Reliable and Quality MRI RF Shielding Enclosures</XXL>
                <LG style={{maxWidth: '1000px'}} paddingTopMd navy light tag="h3">
                  Radio frequency (RF) shielding is required for all MRI scanners. The construction of an RF shielded enclosure reduces the RF noise inside the MRI exam room. Noise sources can originate from radio stations, electrical equipment, and other various things.
                </LG>
              </div>

            </Col>
          </Row>
          <Row style={{marginTop: '30px'}}>
            <Col size={12} sm="auto">
              <Button onClick={goTorequest} pairButton size="large" spacingBottom primary>Inquire About RF Shielding</Button>
            </Col>  
          </Row>
        </div>
      </HeroHeader>

  )
}


export default RfShieldingHero;
